function notEmpty(value) {
  return value !== null && value !== undefined;
}
export default notEmpty;